import { useQuery } from '@tanstack/react-query';
import { cardChangeLogsApi } from '../api/endpoints/cardChangeLogs';
import { toast } from '../store/ui.store';

export const useCardChangeLogs = (cardId: number, page = 0, size = 20) => {
  return useQuery({
    queryKey: ['cardChangeLogs', cardId, page, size],
    queryFn: () => cardChangeLogsApi.getChangeLogs(cardId, page, size),
    enabled: !!cardId
  });
};

export const useExportChangeLogs = () => {
  const exportToExcel = async (cardId: number, cardTitle: string) => {
    try {
      const blob = await cardChangeLogsApi.exportToExcel(cardId);
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${cardTitle.replace(/[^a-z0-9]/gi, '_')}_change_logs.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success('Change logs exported successfully');
    } catch (error: any) {
      toast.error(error.message || 'Failed to export change logs');
    }
  };

  return { exportToExcel };
};
